import React from 'react';
import { Link } from 'react-router-dom';
import { useLanguage } from '../context/LanguageContext';
import SocialIcons from './SocialIcons';
import './Footer.css';

const Footer = () => {
  const { t } = useLanguage();

  return (
    <footer className="footer">
      <div className="footer-container">
        <div className="footer-content">
          <div className="footer-section">
            <h3>PHONESTREAM</h3>
            <p>Revenue Sharing Platform for Music Streaming</p>
          </div>

          <div className="footer-section">
            <h4>Quick Links</h4>
            <ul>
              <li><Link to="/">{t('home')}</Link></li>
              <li><Link to="/marketplace">Marketplace</Link></li>
              <li><Link to="/dashboard">{t('dashboard')}</Link></li>
              <li><Link to="/store">{t('store')}</Link></li>
            </ul>
          </div>

          <div className="footer-section">
            <h4>Legal</h4>
            <ul>
              <li><Link to="/terms">{t('termsAndConditions')}</Link></li>
              <li><Link to="/privacy">{t('privacyPolicy')}</Link></li>
              <li><Link to="/msa">{t('masterServiceAgreement')}</Link></li>
            </ul>
          </div>

          <div className="footer-section">
            <h4>Connect With Us</h4>
            <SocialIcons />
          </div>
        </div>

        <div className="footer-bottom">
          <p>&copy; 2026 PhoneStream Platform. All rights reserved.</p>
          <p className="footer-domains">
            <a href="https://phonestream.online">phonestream.online</a>
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
